import ReservationNewForm from './form/reservation-new.form'
import { ReservationNewFilter } from './form/reservation-new.type'

type ReservationNewDrawerProps = {
  propertyId: string
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  onGoToCreateGroupReservation?: () => void
  onSubmitAndOpenReservation?: (reservationId: string) => void
  filter?: ReservationNewFilter
  reservationId?: string
  planningInfo?: {
    resourceTypeId: string
    resourceId?: string
  }
}

export default function ReservationNewDrawer(props: ReservationNewDrawerProps) {
  const onSubmitComplete = () => {
    props.onConfirm()
  }

  const onCancelHandler = () => {
    props.onCancel()
  }

  return (
    <>
      <ReservationNewForm
        reservationId={props.reservationId}
        formLayoutProps={{
          appearance: {
            type: 'DRAWER',
            open: props.open,
            onClose: () => {
              props.onCancel()
            },
            tight: true,
            titleOnLeft: true,
          },
        }}
        propertyId={props.propertyId}
        onSubmitComplete={onSubmitComplete}
        onCancel={onCancelHandler}
        filter={props.filter}
        planningInfo={props.planningInfo}
        onGoToCreateGroupReservation={props.onGoToCreateGroupReservation}
        onSubmitAndOpenReservation={props.onSubmitAndOpenReservation}
      />
    </>
  )
}
